// @flow

"use strict";


/**
 * 端末情報
 */
export default class Device {
  constructor(code: number){
    this.code = code;  // 端末コード
  }

  /**
   * PC識別コード
   * @returns {number}
   */
  static pcCode(): number {
    return 1;
  }

  /**
   * SP識別コード
   * @returns {number}
   */
  static spCode(): number {
    return 2;
  }

  /**
   * iphone, ipod, ipad, androidがuaの文字列に含まれていなければPC = 1、含まれていなければSP = 2を返す。
   * @return {Device}
   */
  static create(window: Window): Device {
    const ua = window.navigator.userAgent.toLowerCase();
    const code = ua.indexOf('iphone') === -1 && ua.indexOf('ipod') === -1 && ua.indexOf('ipad') === -1 && ua.indexOf('android') === -1 && ua.indexOf('mobile') === -1 ? Device.pcCode() : Device.spCode();
    return new Device(code);
  }

  /**
   * PC判定
   * @returns {boolean}
   */
  isPC(): boolean {
    return this.code === Device.pcCode();
  }

  /**
   * SP判定
   * @returns {boolean}
   */
  isSP(): boolean {
    return this.code === Device.spCode();
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/device.js